var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRemoveCuvetteLid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    stroke: "#ED3431",
    id: "svg_3",
    strokeWidth: 3,
    r: 18.65615,
    cy: 23,
    cx: 23
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    id: "svg_1",
    fill: "#003E6B",
    d: "m36.06238,17.50008l-26.12477,0l0,7.85703l2.61248,0l0,3.14281l20.89981,0l0,-3.14281l2.61248,0l0,-7.85703z",
    clipRule: "evenodd",
    fillRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#ED3431",
    id: "svg_2",
    strokeWidth: 3,
    d: "m35.87495,35.87495l-25.74989,-25.74989"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemoveCuvetteLid);
export default __webpack_public_path__ + "static/media/RemoveCuvetteLid.d78d62ac96b844cab3a8de1826396d59.svg";
export { ForwardRef as ReactComponent };